import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AdminDashboard from "./AdminDashboard";

const AdminDashboardModal = ({ isOpen, onRequestClose }) => {
    const { t } = useTranslation();

    return (
        <Modal 
            show={isOpen} 
            onHide={onRequestClose} 
            size="xl" 
            className="admin-dashboard-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>{t("Admin Control Panel")}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px' }}>
                <AdminDashboard />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onRequestClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AdminDashboardModal;
